import type { Module } from 'vuex';
import { state } from './state';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';
import type { IExamRoomState } from '@/store/modules/examroom/types';
import type { RootState } from '@/store/types';

const namespaced: boolean = true;

export const examRoomModule: Module<IExamRoomState, RootState> = {
  namespaced,
  state,
  actions,
  mutations,
  getters,
};
